import { action } from 'satcheljs/lib/legacy';
import { FeedbackViewState } from '../store/schema/FeedbackViewState';

export default action('clearFeedback')(function clearFeedback(state: FeedbackViewState) {
    state.subjectArea = '';
    state.emailAddresses = [];
    state.subject = '';
    state.message = '';
    state.classification = '';
    state.screenshotBlob = null;
    state.screenshotFileBase64 = null;
});
